// extracted by mini-css-extract-plugin
module.exports = {"emptyPaymentList":"PaymentListView__emptyPaymentList","wrapper":"PaymentListView__wrapper"};